// import {  } from 'graphql-request';

export const UPDATE_USER_NAME = `
  mutation UpdateUserName($user: UserNameInput!) {
    userName(user: $user) {
      firstName
      lastName
    }
  }
`;

export const UPDATE_USER_MERCH_USECASE = `
  mutation MerchantUseCase($muc: [MucInput!]!) {
    merchantUseCase(useCase: $muc) {
      details {
        detailType
        data
      }
    }
  }
`;

export const UPDATE_BUSINESS_TYPE = `
  mutation EntityType($entity: EntityTypeInput!) {
    entityType(entity: $entity) {
      details {
        detailType
        data
      }
    }
  }
`;
export const UPDATE_BRAND_NAME = `
  mutation MerchantBrandName($mbn: MerchantBrandNameInput!) {
    merchantBrandName(brandName: $mbn) {
      details {
        detailType
        data
      }
    }
  }
`;
export const UPDATE_PAN_NUMBER = `
  mutation UpdatePAN($pan: KycInput!) {
    enterPAN(pan: $pan) {
      PAN
      PANFor
      nameOnPAN
    }
  }
`;

export const UPDATE_VERIFY_PAN = `
  mutation UpdatePAN($pan: KycPANVerifyInput!) {
    verifyPAN(pan: $pan) {
      PAN
      PANFor
      nameOnPAN
    }
  }
`;

export const ENTER_AUTHORISED_SIGNATORY_PAN = `
  mutation EnterAuthorisedSignatoryPAN($pan: KycInput!) {
    enterAuthorisedSignatoryPAN(pan: $pan) {
      PAN
      PANFor
      nameOnPAN
    }
  }
`;

export const VERIFY_AUTHORISED_SIGNATORY_PAN = `
  mutation VerifyAuthorisedSignatoryPAN($pan: KycPANVerifyInput!) {
    verifyAuthorisedSignatoryPAN(pan: $pan) {
      PAN
      PANFor
      nameOnPAN
    }
  }
`;

export const UPDATE_ADDRESS_DETAILS = `
  mutation UpdateEntityAddress($entity: EntityAddressInput!) {
    entityAddress(entity: $entity) {
      address {
        address
        state
        city
        pinCode
        type
      }
    }
  }
`;
export const VERIFY_PHONE_NUMBER = `
  mutation UpdateUserPhone($phone: UserPhoneInput!) {
    userPhone(phone: $phone) {
      phone
      resendAttemptsCount
      resendReadyTime
      otpKey
    }
  }
`;

export const CKYC_SEND_OTP = `
  mutation SendOtp($input: SendOtpIndividualCkycInput!) {
    individualCkycSendOtp(input: $input) {
      requestId
      result
    }
  }
`;

export const CKYC_VALIDATE_OTP = `
  mutation IndividualCkycValidateOtp($input: ValidateOtpIndividualCkycInput!) {
    individualCkycValidateOtp(input: $input) {
      statusCode
      requestId
      kycData {
        ckycId
        maskedAadhaar
        name
        gender
        dob
        mobile
        email
        address
        generatedAt
        imageData {
          imageExtension
          imageType
          image
        }
      }
    }
  }
`;

export const INITIATE_LEGAL_CKYC = `
  mutation InitiateLegalCkyc {
    initiateLegalCkyc {
      businessCkycId
      address {
        address
        city
        pinCode
        state
        type
        ckycVerified
      }
    }
  }
`;

export const UPDATE_REVIEW_PAGE = `
  mutation CompleteReviewBasicDetails {
    completeReviewBasicDetails
  }
`;

export const COMPLETE_REVIEW_KYC_DETAILS = `
  mutation CompleteReviewKycDetails {
    completeReviewKycDetails
  }
`;

export const COMPLETE_REVIEW_CKYC_DETAILS = `
  mutation CompleteReviewCKycDetails {
    completeReviewCKycDetails
  }
`;

export const UPDATE_ACCOUNT_DETAILS = `
mutation accountDetails($input: AccountDetailsInput!) {
  accountDetails(accountDetails: $input) {
    accountNo
    ifscCode
  }
}`;

export const UPDATE_GST_DETAILS = `
mutation gstDetails($input: GstDetailsInput!) {
  gstDetails(gstDetails: $input) {
    cin
    gstNo
  }
}`;

export const UPDATE_ID_PROOFS = `
mutation ($idProofs: [IdProofInput!]!, $files: [Upload!]) { 
    idProof(idProofs: $idProofs, files: $files) { 
      masterDocTypeId 
    } 
  }`;

export const UPDATE_BUSINESS_PROOFS = `
  mutation ($idProofs: [IdProofInput!]!, $files: [Upload!]!) { 
    businessIdProof(idProofs: $idProofs, files: $files) { 
        masterDocTypeId 
      } 
    }`;

export const UPDATE_BUSINESS_CATEGORY = `
  mutation BusinessCategory($category: Int!) {
    businessCategory(category: $category) {
      details {
        detailType
        data
      }
    }
  }
`;
export const UPDATE_AADHAAR_PROOFS = `mutation UploadViaDigilocker($idProof: IdProofInput!) {
  uploadViaDigilocker(idProof: $idProof) {
    masterDocTypeId
    redirectURL
  }
}`;

export const UPDATE_MERCHANT_ENTITY_BOOK_SIZE = `
  mutation MonthlyBookSize($input: MonthlyBookSizeInput!) {
    monthlyBookSize(input: $input) {
      details {
        detailType
        data
      }
    }
  }
`;

export const SAVE_DATE_OF_INCORPORATION = `
  mutation SaveDateOfIncorporation($input: DateOfIncorporationInput!) {
    dateOfIncorporation(input: $input) {
      dateOfIncorporation
    }
  }
`;

export const ADD_MERCHANT_DETAILS = `
  mutation AddMerchantDetails($request: MerchantDetailsRequest!) {
    addMerchantDetails(request: $request) {
      details {
        detailType
        data
        status
        makerName
        makerActionAt
        checkerName
        checkerActionAt
        checkerRemarks
      }
    }
  }
`;